import { FC } from 'react';
import { ReactNode } from 'react-markdown/lib/react-markdown';
import OtpV1 from './OtpV1';
import OtpV2 from './OtpV2';

export interface OtpSectionProps {
    numInputs: number | undefined;
    code: string;
    onSetCode: (val: string) => void;
    goBackClick?: () => void;
    showResendCode: boolean;
    backButton?: boolean;
    resendSms?: () => void;
    resendSmsCooldown?: number;
    isReachedLimit?: boolean;
    error?: boolean | string;
    resendTimer?: boolean;
}

interface IProps extends OtpSectionProps {
    fullPage?: boolean;
    children?: ReactNode;
}

const OTP: FC<IProps> = (props) => {
    if (props.fullPage) {
        return (
            <OtpV2
                numInputs={props?.numInputs}
                code={props.code}
                onSetCode={props.onSetCode}
                goBackClick={props.goBackClick}
                showResendCode={props.showResendCode}
                resendSms={props.resendSms}
                resendSmsCooldown={30}
                resendTimer={props.resendTimer}
                error={props.error}
            />
        );
    }

    return (
        <OtpV1
            numInputs={props?.numInputs}
            code={props.code}
            onSetCode={props.onSetCode}
            goBackClick={props.goBackClick}
            showResendCode={props.showResendCode}
            resendSms={props.resendSms}
            resendSmsCooldown={30}
            backButton
        />
    );
};
export default OTP;
